// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Dochf","scrollContainer":"styles_scrollContainer__I7bcN","textarea":"styles_textarea__dfDW9","postfix":"styles_postfix__Di74b"};